module.exports = __webpack_public_path__ + "menu_0.d6180f85.png";